import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { NavLink, useLocation } from 'react-router-dom'
import { routePaths } from '../route_paths'
import { IRootState } from '../store'
import Button from './Button'
import { ILoggedUser } from '../typeScript/interfaces/IUser'
import { roleUtils } from '../utils/roleUtils'

export type Props = {
  mobileMenuOpen: boolean
  onClick: (e) => void
  handleLogout: () => void
  handleSwitchPortal: () => void
  isPortal: boolean
}

const PortalLinks = [
  {
    path: routePaths.portalOverview,
    label: 'overview',
  },
  {
    path: routePaths.portalCharger,
    label: 'charger',
  },
  {
    path: routePaths.portalDocuments,
    label: 'documents',
  },
  {
    path: routePaths.portalSupport,
    label: 'support',
  },
  {
    path: routePaths.portalCards,
    label: 'chargingCards',
  },
  {
    path: routePaths.portalPayment,
    label: 'my_payment',
  },
  {
    path: routePaths.portalProfile,
    label: 'Profile',
  },
  {
    path: routePaths.portalTariff,
    label: 'tariff',
  },
  {
    path: routePaths.portalPayout,
    label: 'payout',
  },
  {
    path: routePaths.portalFleetData,
    label: 'fleetData',
  },
]

function MobileMenu(props: Props) {
  const { mobileMenuOpen, onClick, handleLogout, handleSwitchPortal } = props
  const { t } = useTranslation(['nav'])
  const location = useLocation()
  const user = useSelector<IRootState, ILoggedUser | null>(
    (state) => state.user.user
  )

  // Check if current user has manager role from JWT token
  const currentUser = roleUtils.getCurrentUser()
  const isManager = roleUtils.isManager(currentUser)

  const navLinks = PortalLinks.map((link, i) => {
    let dynamicActiveClass = ''
    const activeClassName = i > 0 ? 'nav__link--active' : ''
    let doRender = true

    if (i === 0) {
      const route = routePaths.portalOverview
      dynamicActiveClass =
        location.pathname === route ? ' nav__link--active' : ''
    }

    if (link.path === routePaths.portalPayment) {
      doRender = user?.canUpdatePaymentInformation ? true : false
    }
    if (link.path === routePaths.portalPayout) {
      doRender = user?.isReimbursementActivated ? true : false
    }
    if (link.path === routePaths.portalFleetData) {
      doRender = user?.isFleetDataEnrichment ? true : false
    }

    return (
      doRender && (
        <NavLink
          to={link.path}
          className={({ isActive }) =>
            `nav__link nav__link--mob ${dynamicActiveClass}` +
            (isActive ? ` ${activeClassName}` : '')
          }
          onClick={onClick}
          key={link.label}
        >
          <p className="nav__link__text nav__link__text--mob">
            {t(link.label)}
          </p>
        </NavLink>
      )
    )
  })

  return (
    <>
      <div
        className={`mobile-menu
                    ${mobileMenuOpen ? 'mobile-menu--show' : ''}
                `}
      >
        <div className="mobile-menu__content">
          <div className="mobile-menu__content__links">
            {navLinks}
            {isManager && (
              <span
                className="nav__link nav__link--mob"
                onClick={handleSwitchPortal}
              >
                <p className="nav__link__text nav__link__text--mob">
                  {t('switch_portal')}
                </p>
              </span>
            )}
          </div>
        </div>
        <div className="mobile-menu__content__bottom">
          <Button onClick={handleLogout}>{t('log_out')}</Button>
          {/*<LanguageSwitcher type='box'/>*/}
        </div>
      </div>
      <div
        className={`mobile-menu__bg ${
          mobileMenuOpen ? 'mobile-menu__bg--show' : ''
        }`}
        onClick={onClick}
      />
    </>
  )
}

export default MobileMenu
